import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Grid } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import TextField from "@mui/material/TextField";
import VisitUs from "../components/VisitUs";
import axios from "axios";
import { API_URL } from "../actions/auth";
import { alertMessage } from "../actions/auth";

export default function Contact() {
  const state = useSelector((state) => state);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {}, []);

  function onSubmit(e) {
    e.preventDefault();
    var body = {};
    body["name"] = name;
    body["email"] = email;
    body["phone_number"] = phoneNumber;
    body["subject"] = subject;
    body["content"] = description;

    axios
      .post(API_URL + "new_contact", JSON.stringify(body))
      .then((res) => {
        dispatch(
          alertMessage(
            "SUCCESS",
            "SUCCESS",
            "Your request has been submitted. Our team will get back to you.",
          ),
        );
      })
      .catch((err) => {});
  }

  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div className="overlay"></div>

        <div
          className="abouthero"
          style={{
            background:
              "linear-gradient(0deg, rgba(2, 77, 194, 0.2), rgba(2, 77, 194, 0.2)), url('" +
              require("../img/AGIS (5).jpeg") +
              "')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div
            style={{
              fontSize: state.auth.isMobile ? "30px" : "30px",
              fontWeight: "bold",
              fontFamily: "Montserrat",
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryButtonTextColor
                  : themeStyle.primaryButtonTextColor,
            }}
          >
            Contact Us
          </div>
        </div>
        <div className="aboutabout" style={{ marginTop: "100px" }}>
          <Grid container spacing={5}>
            <Grid
              item
              xs={12}
              md={5}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <div
                style={{
                  fontSize: state.auth.isMobile ? "30px" : "30px",
                  fontWeight: "bold",
                  fontFamily: "Montserrat",
                  textAlign: "left",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                }}
              >
                Ask us anything. Anytime.
              </div>
              <br />
              <Link
                style={{
                  textDecoration: "none",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.textColor
                      : themeStyle.textColor,
                }}
                to={"/contact"}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <LocationOnIcon
                    className="nav-icon"
                    style={{
                      fontSize: 35,
                      color:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  />
                  <div
                    style={{
                      marginLeft: "20px",
                      marginTop: "5px",
                      fontSize: state.auth.isMobile ? "18px" : "25px",
                      fontFamily: "Montserrat",
                      textAlign: "left",
                    }}
                  >
                    Ward No 22, Sulibele road, near Sattva Park Cubix, Shanthi
                    Nagara, Devanahalli, Devanahally, Karnataka 562110
                  </div>
                </div>
              </Link>
              <Link
                style={{
                  textDecoration: "none",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.textColor
                      : themeStyle.textColor,
                }}
                to={"/contact"}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <EmailIcon
                    className="nav-icon"
                    style={{
                      fontSize: 35,
                      color:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  />
                  <div
                    style={{
                      marginLeft: "20px",
                      marginTop: "5px",
                      fontSize: state.auth.isMobile ? "18px" : "25px",
                      fontFamily: "Montserrat",
                      textAlign: "justify",
                    }}
                  >
                    admissions@slvgroup.org
                  </div>
                </div>
              </Link>
              <Link
                style={{
                  textDecoration: "none",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.textColor
                      : themeStyle.textColor,
                }}
                to={"/contact"}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <LocalPhoneIcon
                    className="nav-icon"
                    style={{
                      fontSize: 35,
                      color:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  />
                  <div
                    style={{
                      marginLeft: "20px",
                      marginTop: "5px",
                      fontSize: state.auth.isMobile ? "18px" : "25px",
                      fontFamily: "Montserrat",
                      textAlign: "justify",
                    }}
                  >
                    9916611104 / 9916611106
                  </div>
                </div>
              </Link>
              <Link
                style={{
                  textDecoration: "none",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.textColor
                      : themeStyle.textColor,
                }}
                to={"/contact"}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <LocalPhoneIcon
                    className="nav-icon"
                    style={{
                      fontSize: 35,
                      color:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  />
                  <div
                    style={{
                      marginLeft: "20px",
                      marginTop: "5px",
                      fontSize: state.auth.isMobile ? "18px" : "25px",
                      fontFamily: "Montserrat",
                      textAlign: "justify",
                    }}
                  >
                    9916611104 / 9916611106
                  </div>
                </div>
              </Link>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={7}
              xl={7}
              style={{ justifyContent: "center" }}
            >
              <form onSubmit={onSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <TextField
                      sx={{
                        backgroundColor:
                          state.auth.theme == "dark"
                            ? themeStyleDark.backgroundColor
                            : themeStyle.backgroundColor,
                        color:
                          state.auth.theme == "dark"
                            ? themeStyleDark.textColor
                            : themeStyle.textColor,
                        borderRadius: "6px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid " + themeStyle.primaryColor,
                        },
                        "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                          {
                            color: themeStyle.primaryColor,
                            fontWeight: "bold",
                            opacity: 1,
                            fontFamily: "Montserrat",
                          },
                      }}
                      variant="outlined"
                      required
                      fullWidth
                      margin="normal"
                      name="name"
                      autoComplete="name"
                      autoFocus
                      placeholder="Name *"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                        dispatch({
                          type: "NAV_COLOR",
                          payload: {
                            navColor: themeStyle.secondaryButtonColor,
                            navOpacity: 1,
                          },
                        });
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <TextField
                      sx={{
                        backgroundColor:
                          state.auth.theme == "dark"
                            ? themeStyleDark.backgroundColor
                            : themeStyle.backgroundColor,
                        color:
                          state.auth.theme == "dark"
                            ? themeStyleDark.textColor
                            : themeStyle.textColor,
                        borderRadius: "6px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid " + themeStyle.primaryColor,
                        },
                        "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                          {
                            color: themeStyle.primaryColor,
                            fontWeight: "bold",
                            opacity: 1,
                            fontFamily: "Montserrat",
                          },
                      }}
                      variant="outlined"
                      required
                      fullWidth
                      margin="normal"
                      name="email"
                      autoComplete="email"
                      autoFocus
                      placeholder="E-mail *"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        dispatch({
                          type: "NAV_COLOR",
                          payload: {
                            navColor: themeStyle.secondaryButtonColor,
                            navOpacity: 1,
                          },
                        });
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <TextField
                      sx={{
                        backgroundColor:
                          state.auth.theme == "dark"
                            ? themeStyleDark.backgroundColor
                            : themeStyle.backgroundColor,
                        color:
                          state.auth.theme == "dark"
                            ? themeStyleDark.textColor
                            : themeStyle.textColor,
                        borderRadius: "6px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid " + themeStyle.primaryColor,
                        },
                        "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                          {
                            color: themeStyle.primaryColor,
                            fontWeight: "bold",
                            opacity: 1,
                            fontFamily: "Montserrat",
                          },
                      }}
                      variant="outlined"
                      required
                      fullWidth
                      margin="normal"
                      name="phonenumber"
                      autoComplete="phonenumber"
                      autoFocus
                      placeholder="Phone number *"
                      value={phoneNumber}
                      onChange={(e) => {
                        setPhoneNumber(e.target.value);
                        dispatch({
                          type: "NAV_COLOR",
                          payload: {
                            navColor: themeStyle.secondaryButtonColor,
                            navOpacity: 1,
                          },
                        });
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <TextField
                      sx={{
                        backgroundColor:
                          state.auth.theme == "dark"
                            ? themeStyleDark.backgroundColor
                            : themeStyle.backgroundColor,
                        color:
                          state.auth.theme == "dark"
                            ? themeStyleDark.textColor
                            : themeStyle.textColor,
                        borderRadius: "6px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid " + themeStyle.primaryColor,
                        },
                        "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                          {
                            color: themeStyle.primaryColor,
                            fontWeight: "bold",
                            opacity: 1,
                            fontFamily: "Montserrat",
                          },
                      }}
                      variant="outlined"
                      required
                      fullWidth
                      margin="normal"
                      name="subject"
                      autoComplete="subject"
                      autoFocus
                      placeholder="Subject *"
                      value={subject}
                      onChange={(e) => {
                        setSubject(e.target.value);
                        dispatch({
                          type: "NAV_COLOR",
                          payload: {
                            navColor: themeStyle.secondaryButtonColor,
                            navOpacity: 1,
                          },
                        });
                      }}
                    />
                  </Grid>
                </Grid>
                <TextField
                  sx={{
                    backgroundColor:
                      state.auth.theme == "dark"
                        ? themeStyleDark.backgroundColor
                        : themeStyle.backgroundColor,
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.textColor
                        : themeStyle.textColor,
                    borderRadius: "6px",
                    height: "400",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid " + themeStyle.primaryColor,
                    },
                    "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                      {
                        color: themeStyle.primaryColor,
                        fontWeight: "bold",
                        opacity: 1,
                        fontFamily: "Montserrat",
                      },
                  }}
                  variant="outlined"
                  required
                  fullWidth
                  margin="normal"
                  name="description"
                  autoComplete="description"
                  multiline
                  rows={7}
                  autoFocus
                  placeholder="Description of your enquiry *"
                  value={description}
                  onChange={(e) => {
                    setDescription(e.target.value);
                    dispatch({
                      type: "NAV_COLOR",
                      payload: {
                        navColor: themeStyle.secondaryButtonColor,
                        navOpacity: 1,
                      },
                    });
                  }}
                />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "20px",
                  }}
                >
                  <Button
                    style={{
                      width: "100%",
                      height: "60px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryButtonColor
                          : themeStyle.primaryButtonColor,
                      color:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryButtonTextColor
                          : themeStyle.primaryButtonTextColor,
                    }}
                    type="submit"
                    variant="contained"
                  >
                    <span
                      style={{
                        fontSize: state.auth.isMobile ? "18px" : "25px",
                        fontWeight: "bold",
                        fontFamily: "Montserrat",
                      }}
                    >
                      SUBMIT REQUEST
                    </span>
                  </Button>
                </div>
              </form>
            </Grid>
          </Grid>
        </div>
        <div className="aboutabout2">
          <div
            style={{
              width: "90%",
              textAlign: "justify",
              marginTop: "-150px",
              paddingBottom: "50px",
              fontSize: state.auth.isMobile ? "18px" : "22px",
            }}
          >
            {/* Section 6: Uniform */}
            <div
              style={{
                fontSize: "32px",
                fontFamily: "Montserrat",
                textAlign: "left",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                fontWeight: "bold",
              }}
            >
              We will be in touch shortly
            </div>
            <br />
            Join our community and be a part of your child’s journey with us.
            <br />
            Have an Inquiry?
            <br />
            Don’t hesitate to contact us
            <br />
            We’re here to make it easy for you to get in touch. We welcome your
            inquiries and look forward to hearing from you.
            <br />
            Follow our social media : Facebook / Instagram
          </div>
        </div>
        <div className="aboutabout2" style={{ marginTop: "-100px" }}>
          <div
            style={{
              width: "90%",
              textAlign: "justify",
              marginTop: "-150px",
              paddingBottom: "50px",
              fontSize: state.auth.isMobile ? "18px" : "22px",
            }}
          >
            {/* Section 6: Uniform */}
            <div
              style={{
                fontSize: "32px",
                fontFamily: "Montserrat",
                textAlign: "left",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                fontWeight: "bold",
              }}
            >
              Educational Philosophy{" "}
            </div>
            <br />
            Why Aspire Grove International?
            <br />
            We believe that every activity is an opportunity for growth and
            learning, whether it be through play, daily routines, social
            interactions, or academics.
            <br /> At AGI, learning is everywhere!
            <br />
            With English as the primary language of instruction and Kannada and
            Hindi offered as cultural languages, our diverse curriculum inspires
            children to explore, imagine, and wonder.
            <br />
            We nurture independent thinkers who are confident to share their
            ideas, respect others, and believe in themselves. At AGI, children
            are encouraged not just to achieve, but to grow into compassionate
            leaders ready for the world.
          </div>
        </div>
        <div className="aboutabout2" style={{ marginTop: "-100px" }}>
          <div
            style={{
              width: "90%",
              textAlign: "justify",
              marginTop: "-150px",
              paddingBottom: "50px",
              fontSize: state.auth.isMobile ? "18px" : "22px",
            }}
          >
            {/* Section 6: Uniform */}
            <div
              style={{
                fontSize: "32px",
                fontFamily: "Montserrat",
                textAlign: "left",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                fontWeight: "bold",
              }}
            >
              What is “whole-child” education?
            </div>
            <br />
            "Whole-child" education is based on the concept that children are
            "whole" and acknowledges that children need to have experiences that
            foster their intellect, body control and expression, creativity,
            musical talents, relationships, and so much more!
            <br />
            <br />
            We know that it is important to educate children by giving them a
            range of experiences which can solidify their understanding of
            concepts, as well as monitoring, evaluating, and sharing their
            progress.
            <br />
            <br />
            We believe that every activity is an opportunity for growth and
            learning, whether it be through play, movement, music, sensory
            experiences, scientific exploration, social interactions, or
            academics. We identify and extend each child's strengths and assist
            them in areas where they are not yet comfortable.
            <br />
            <br />
            By providing a rich learning environment, we nourish a child’s sense
            of achievement and their desire to persevere with their learning. We
            provide them with a tool box full of experience, knowledge and
            understanding.
            <br />
            <br />
            At AGI, learning is everywhere! The experiences and growth
            opportunities your child encounters at AGI are sure to lead to new
            discoveries and ever greater ability to reach for the stars!
          </div>
        </div>
        <VisitUs />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
